import { AssessmentSectionSubjectVisibility } from "types/graphql-schema";

import Callout from "@components/callout/callout";

const AssessmentSectionSubjectVisibilityBanner = ({
  subjectVisibility,
  inDelivery = false,
  className,
}: {
  inDelivery?: boolean;
  subjectVisibility?: AssessmentSectionSubjectVisibility;
  className?: string;
}) => {
  return (
    <Callout
      size="small"
      theme={
        subjectVisibility ===
        AssessmentSectionSubjectVisibility.AllQuestionsAreVisible
          ? "success"
          : subjectVisibility ===
                AssessmentSectionSubjectVisibility.SomeQuestionsAreHidden ||
              subjectVisibility ===
                AssessmentSectionSubjectVisibility.SomeQuestionsAreHiddenButSomeAreSubjectOnly
            ? "default"
            : "warning"
      }
      icon={
        subjectVisibility ===
        AssessmentSectionSubjectVisibility.AllQuestionsAreHidden
          ? "eyeOff"
          : "eye"
      }
      className={className}
    >
      {subjectVisibility ===
      AssessmentSectionSubjectVisibility.AllQuestionsAreVisible
        ? "All questions in this section are visible to the subject."
        : subjectVisibility ===
              AssessmentSectionSubjectVisibility.SomeQuestionsAreHiddenButSomeAreSubjectOnly &&
            !inDelivery
          ? "Some of the questions in this section are visible to the subject. Some are also hidden from you during the submission because only the subject needs to answer them."
          : subjectVisibility ===
                AssessmentSectionSubjectVisibility.SomeQuestionsAreHidden ||
              subjectVisibility ===
                AssessmentSectionSubjectVisibility.SomeQuestionsAreHiddenButSomeAreSubjectOnly
            ? "Some of the questions in this section are visible to the subject."
            : "This entire section will be hidden from the subject"}
    </Callout>
  );
};

export default AssessmentSectionSubjectVisibilityBanner;
